/**
 * Node Prop change event
 * @Deprecated Please Replace With InnerPropChange
 */
export var Change = 'node.prop.change';

/** Node Prop change event */
export var InnerChange = 'node.innerProp.change';